module.exports = __webpack_public_path__ + "img/vmd.01552aee.svg";